import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { legacy_createStore as createStore } from "redux"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

import App from "./app/App"
//import { reducer } from "./core/reducers"
import { reducer } from "./core/reducers/redux/playerReducer"
import "./styles/index.css"

gsap.registerPlugin(ScrollTrigger)

// ===============================
// VIEW TRANSITION SETUP (STEP 5)
// ===============================
if (typeof document !== "undefined") {
  document.documentElement.style.viewTransitionName = "app-root"
}

console.log(
  "%cMixtapeRadio",
  "color:#85b8ff;font-size:10px;font-family:Verdana;font-weight:800;background-color:rgba(6,110,255,.5);padding:5px 40px;border-radius:2rem"
)

const store = createStore(reducer)

// ===============================
// ROOT RENDER (NO CHANGES HERE)
// ===============================
function Root() {
  return (
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  )
}

const container = document.getElementById("root")

if (!container) {
  throw new Error("Root container missing")
}

// ===============================
// NATIVE RENDER PIPELINE
// ===============================
const root = createRoot(container)

root.render(<Root />)
